module.exports = __webpack_public_path__ + "media/images/person-1bcf5869.svg";